import React, { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import Tooltip from "@mui/material/Tooltip";
import { getLayerName } from "../../TimeLine/MainTimeLineVisible";
import { LocationMarkerPopup } from "../../mainLayer/MainWindow";
import { ThemeProvider, useTheme } from "../../theme/ThemeContext";
import { useMenu} from "../../roundMenuContext/roundMenuContext";
import { useHzContext } from "../../provider/HzProvider";


interface ReportIncidentsProps {
  senddValueFromHazardIncidentsMenu: (value: string) => void;
  openIncidentDropDown: (open: boolean) => void;
  openTitle: string;
  clickedHzIncident: boolean;
  showPopupDropDown: boolean;
}

const ReportIncidents: React.FC<ReportIncidentsProps> = ({
  senddValueFromHazardIncidentsMenu,
  openIncidentDropDown,
  openTitle,
  clickedHzIncident,
  showPopupDropDown,
}) => {
  const buttonRef = useRef<HTMLButtonElement>(null);
  const [isClicked, setIsClicked] = useState<boolean>(true);
  const [hoveredReportedIncident, setHoveredReportedIncident] = useState(false);
  const { theme } = useTheme();
  const { menu } = useMenu();
  const { HzOpenSidebarMap, clearHzOpenSidebarMap,clickedHzString } = useHzContext();

  useEffect(() => {
    if (menu==="Reported Incidents") {
      toggleDropDown();
    } 
  }, [menu]);

  useEffect(() => {
    if (clickedHzString==="clickHz") {
      toggleDropDown();
    } 
  }, [clickedHzString]);

  const toggleDropDown = () => {
    openIncidentDropDown(true);
    senddValueFromHazardIncidentsMenu("Reported Incidents");

    if (!clickedHzIncident) {
      setIsClicked((prevState) => !prevState);
    }

    getLayerName("hzIncidents", true);
  };

  useEffect(() => {
    if (openTitle !== "main") {
      if (openTitle === "Reported Incidents") {
        setIsClicked(false);
      } else {
        if (clickedHzIncident) {
          setIsClicked(false);
        } else {
          setIsClicked(true);
        }
      }
    }
  }, [openTitle]);

  useEffect(() => {
    if (!isClicked) {
      getLayerName("hzIncidents", true);
      LocationMarkerPopup("hzIncidents");
    } else {
      LocationMarkerPopup("hzIncidents not");
      clearHzOpenSidebarMap();
    }
  }, [isClicked]);

  useEffect(() => {
    if (showPopupDropDown === false && clickedHzIncident === false) {
      setIsClicked(true);
    }
  }, [showPopupDropDown]);

  useEffect(() => {
    if (clickedHzIncident) {
      setIsClicked(false);
    } else {
      setIsClicked(true);
    }
  }, [clickedHzIncident]);

  return (
    <>
      <div className="leftsidemenulist-btn-cover" onClick={toggleDropDown}  onTouchStart={toggleDropDown}>
        <div
          onMouseEnter={() => setHoveredReportedIncident(true)}
          onMouseLeave={() => setHoveredReportedIncident(false)}
          className="leftsidemenulist-btns">
          <FontAwesomeIcon
            size="1x"
            icon={faExclamationTriangle}
            className="leftside-icon"
          />
        </div>
        {theme === "light" && (
        <div
          className={
            isClicked
              ? hoveredReportedIncident
                ? "leftsidemenulist-btn-tooltip-hover-light"
                : "leftsidemenulist-btn-tooltip-light"
              : "leftsidemenulist-btn-tooltip-clicked-light"
          }
          onMouseEnter={() => setHoveredReportedIncident(true)}
          onMouseLeave={() => setHoveredReportedIncident(false)}
        >
          Reported Incidents
        </div>
        )}
         {theme !== "light" && (
        <div
          className={
            isClicked
              ? hoveredReportedIncident
                ? "leftsidemenulist-btn-tooltip-hover"
                : "leftsidemenulist-btn-tooltip"
              : "leftsidemenulist-btn-tooltip-clicked"
          }
          onMouseEnter={() => setHoveredReportedIncident(true)}
          onMouseLeave={() => setHoveredReportedIncident(false)}
        >
          Reported Incidents
        </div>
         )}
      </div>
    </>
  );
};

export default ReportIncidents;
